export enum SnackbarType {
  Error = 'error',
  Info = 'info',
  Success = 'success'
}
